import Vue from 'vue'
import Router from 'vue-router'
import {middleware} from 'vue-router-middleware'
import auth_router from "./auth_router"

import DefaultLayout from '@/layouts/Default.vue'
import Errors from '../views/Errors.vue'
import Login from '../views/auth/Login'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'open active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: DefaultLayout,
      children: middleware('only-auth', auth_router)
    },
    ...middleware('only-guest', [
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
    ]),
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
    },
    {
      path: '*',
      redirect: '/errors',
    },
  ],
});
